import { render, staticRenderFns } from "./CustomPricingBox.vue?vue&type=template&id=b9fcf7f4&scoped=true&"
import script from "./CustomPricingBox.vue?vue&type=script&lang=js&"
export * from "./CustomPricingBox.vue?vue&type=script&lang=js&"
import style0 from "./CustomPricingBox.vue?vue&type=style&index=0&id=b9fcf7f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fcf7f4",
  null
  
)

export default component.exports